import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{if this.clampedText this.clampedText this.text}}",{ moduleName: "garaje/pods/components/line-clamp/template.hbs" })